import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';

import { outlinedButtonClasses } from 'us-react-components/dist/Button/Button';
import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { HiddenReasonType } from 'us-web-services';
import { useDependencies } from '../../dependencies';
import { Link } from '..';

const JoinFacebookGroup = (): JSX.Element => {
  const { stores } = useDependencies();
  const { t } = useSharedTranslation(namespaces.caregiver);
  const { sitter: { sitter } } = stores;

  // the facebook group button is an external link
  const fakeButtonClasses = 'flex justify-center items-center w-full whitespace-nowrap px-5 cursor-pointer text-sapphire border-sapphire py-[0.7rem] rounded-full bg-transparent border '
    + outlinedButtonClasses;

  return (
    <div className='flex w-full my-6'>
        {sitter?.hiddenReason !== HiddenReasonType.DECISION && (
          <Link
            id='join-facebook-group-btn'
            to='https://www.facebook.com/groups/173689669398648/'
            className={fakeButtonClasses}
            newTab
          >
            {t('pages.sitter.dashboard.joinGroupButton')}
            <FontAwesomeIcon icon={faArrowRight} className='ml-2' />
          </Link>
        )}
    </div>
  )
}

export { JoinFacebookGroup };
